module.exports = __webpack_public_path__ + "img/sign_title.d1521fb1.png";